(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;
  document.documentElement.classList.add('mt-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    (root || document).querySelectorAll('.mt-reveal, [data-mt-observa]').forEach(function (el) {
      if (el.dataset.mtRv) return; el.dataset.mtRv = '1';
      if (io && !reduce) io.observe(el); else el.classList.add('mt-visible');
    });
  }

  function initHero(root) {
    (root || document).querySelectorAll('.mt-hero').forEach(function (h) {
      if (h.dataset.mtInit) return; h.dataset.mtInit = '1';
      requestAnimationFrame(function () { setTimeout(function () { h.classList.add('mt-listo'); }, 60); });
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      var foco = h.querySelector('.mt-hero-foco'); if (!foco) return;
      var raf = null;
      h.addEventListener('mousemove', function (ev) {
        var r = h.getBoundingClientRect();
        var x = ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%';
        var y = ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%';
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { foco.style.setProperty('--mx', x); foco.style.setProperty('--my', y); });
      });
      h.addEventListener('mouseleave', function () { foco.style.removeProperty('--mx'); foco.style.removeProperty('--my'); });
    });
  }

  function initMagnetico(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-mt-magnetico]').forEach(function (b) {
      if (b.dataset.mtMag) return; b.dataset.mtMag = '1';
      b.addEventListener('mousemove', function (ev) {
        var r = b.getBoundingClientRect();
        var dx = (ev.clientX - r.left - r.width / 2) / r.width * 10;
        var dy = (ev.clientY - r.top - r.height / 2) / r.height * 8;
        b.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function initHotspots(root) {
    (root || document).querySelectorAll('.mt-hs').forEach(function (s) {
      if (s.dataset.mtInit) return; s.dataset.mtInit = '1';
      var puntos = s.querySelectorAll('.mt-hs-punto');
      var items = s.querySelectorAll('.mt-hs-item');
      function activar(i) {
        puntos.forEach(function (p, j) { p.setAttribute('aria-expanded', j === i ? 'true' : 'false'); });
        items.forEach(function (it, j) { it.classList.toggle('mt-activo', j === i); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () { activar(i); if (window.innerWidth < 990 && items[i]) items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
        p.addEventListener('mouseenter', function () { activar(i); });
      });
      items.forEach(function (it, i) {
        it.addEventListener('click', function () { activar(i); });
        it.addEventListener('mouseenter', function () { activar(i); });
      });
      activar(0);
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.mt-faq-item').forEach(function (it) {
      if (it.dataset.mtInit) return; it.dataset.mtInit = '1';
      var b = it.querySelector('.mt-faq-q');
      b.addEventListener('click', function () {
        var abierto = it.classList.toggle('mt-abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('.mt-prod-galeria').forEach(function (g) {
      if (g.dataset.mtInit) return; g.dataset.mtInit = '1';
      var principal = g.querySelector('.mt-prod-principal img');
      g.querySelectorAll('.mt-prod-mini').forEach(function (m) {
        m.addEventListener('click', function () {
          g.querySelectorAll('.mt-prod-mini').forEach(function (x) { x.classList.remove('mt-activo'); });
          m.classList.add('mt-activo');
          principal.style.opacity = '0';
          setTimeout(function () { principal.src = m.dataset.src; principal.srcset = ''; principal.style.opacity = '1'; }, 150);
        });
      });
    });
  }

  function initVariantes(root) {
    (root || document).querySelectorAll('[data-mt-producto]').forEach(function (f) {
      if (f.dataset.mtInit) return; f.dataset.mtInit = '1';
      var datos = f.querySelector('script[type="application/json"]'); if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var selects = f.querySelectorAll('.mt-prod-opcion select');
      var input = f.querySelector('input[name="id"]');
      var precio = f.querySelector('[data-mt-precio]');
      var tachado = f.querySelector('[data-mt-tachado]');
      var boton = f.querySelector('button[name="add"]');
      var txtComprar = boton ? boton.dataset.texto : '';
      var txtAgotado = boton ? boton.dataset.agotado : '';
      function actualizar() {
        var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) { if (boton) { boton.disabled = true; boton.textContent = txtAgotado; } return; }
        input.value = v.id;
        if (precio) precio.textContent = v.precio_txt;
        if (tachado) { if (v.tachado_txt) { tachado.textContent = v.tachado_txt; tachado.hidden = false; } else { tachado.hidden = true; } }
        if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? txtComprar : txtAgotado; }
      }
      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root); initHero(root); initMagnetico(root); initHotspots(root); initFaq(root); initGaleria(root); initVariantes(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
